import { ElementType } from '@editor2/types/pageElements';

export const DOUBLE_ELEMENTS = [ElementType.NestingInstruction, ElementType.QuestionDeck];
